import { render, staticRenderFns } from "./PageRouter.vue?vue&type=template&id=7300d0d4&"
import script from "./PageRouter.vue?vue&type=script&lang=js&"
export * from "./PageRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports